import request from '@/utils/request'

let Ma_positionApi = {

  /*岗位列表*/
  list(data) {
    return request._post('/shop/plus.ma_position.Index/index', data);
},
/*添加岗位*/
add(data) {
    return request._post('/shop/plus.ma_position.Index/add', data);
},
/*修改岗位*/
edit(data) {
    return request._post('/shop/plus.ma_position.Index/edit', data);
},
/*删除岗位*/
del(data) {
    return request._post('/shop/plus.ma_position.Index/del', data);
},
/*岗位详情*/
detail(data) {
  return request._post('/shop/plus.ma_position.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.ma_position.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.ma_position.Setting/getSetting', data, errorback);
    },
}
export default Ma_positionApi;



// WEBPACK FOOTER //
// ./src/api/ma_position.js